import axios from 'axios';
import UrlsUtil from '../../utils/url.util';

const apiBaseUrl = UrlsUtil.determineApiBaseUrl(window);
const apiKey = `${process.env.REACT_APP_APIKEY}`;

export default class FlowsService {
  static getActive = async (): Promise<any> => {
    const url = `${apiBaseUrl}/api/Flow/active`;
    return await axios.get(url);
  };

  static getAll = async (): Promise<any> => {
    const url = `${apiBaseUrl}/api/Flow/all`;
    return await axios.get(url);
  };

  static persist = async (activeFlows: string): Promise<any> => {
    const url = `${apiBaseUrl}/api/Flow/persist`;
    let authToken = window.localStorage.getItem('basicAuthHeader')
    return await axios.post(url, { activeFlows: activeFlows }, { headers: { 'Authorization': authToken } });
  };

  static persistDefault = async (key: string, version: string): Promise<any> => {
    const url = `${apiBaseUrl}/api/Flow/persistdefault`;
    let authToken = window.localStorage.getItem('basicAuthHeader');
    const request = { flowKey: key, version: version };
    return await axios.post(url, request, { headers: { 'Authorization': authToken } });
  };

  static persistInactive = async (inactiveFlows: string): Promise<any> => {
    const url = `${apiBaseUrl}/api/Flow/persistinactive`;
    let authToken = window.localStorage.getItem('basicAuthHeader')
    return await axios.post(url, { inactiveFlows: inactiveFlows }, { headers: { 'Authorization': authToken } });
  };

  static populate = async (): Promise<any> => {
    const url = `${apiBaseUrl}/api/Flow/populate`;
    let authToken = window.localStorage.getItem('basicAuthHeader')
    return await axios.post(url, {}, { headers: { 'Authorization': authToken, 'apiKey': apiKey } });
  };
};